export default __webpack_public_path__ + "static/media/photo5.11b47af5.jpeg";